import { schema } from 'normalizr';

export default new schema.Entity('classificationsPlayerCount', {}, {
	idAttribute: 'classification', // one-to-one relation
	processStrategy: (classificationPlayerCount) => ({
		// Meta.
		_type: 'classificationPlayerCount',
		// Fields.
		...classificationPlayerCount,
	}),
});
